import * as devisConf from '@/configuration/devisConf';

export default function miseAJourTva(lignesCommande, tva) {
  lignesCommande.forEach(ligne => {
    if (ligne.type === devisConf.NORMAL) {
      ligne.tauxTva = tva;
    }
    if (ligne.type === devisConf.REGROUPEMENT) {
      ligne.lignesCommande.forEach(ligneEnfant => {
        ligneEnfant.tauxTva = tva;
      });
    }
  });
}
